import { takeUntil } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BarcodeFormat } from '@zxing/library';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { debounceTime, distinctUntilChanged, filter, map, Observable, switchMap } from 'rxjs';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { PropertyItemService } from '../../Services/Custom/ServicePropertyItem';
import { SearchService } from '../../Services/Custom/ServiceSearch';
import { StorageSpaceService } from '../../Services/Custom/ServiceStorageSpace';

@Component({
	selector: 'PropertyItemMoveBulk-edit',
	templateUrl: 'PropertyItemMoveBulk.html',
	
})
export class PropertyItemMoveBulkComponent extends BaseEditPopUpComponent implements OnInit {

	ngOnInit(): void {
	}

	scanSuccess(val: string) {
		if (val && val.length > 2) {
			var searchObj: TooBig4Car.Logic.SearchVM = {
				SearchText: val
			};
			this.mySearchService.search(searchObj)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(col => {
					if (col.length) {
						var obj = col[0];
						if (obj.TypeObject == "StorageSpace") {
							this.myItem.NewStorageSpaceID = obj.ID;
							this.myItem.NewStorageSpaceName = obj.SearchName;
						}
					}
				});
		}
	}
	camerasNotFound(devices: MediaDeviceInfo[]) {
		this.qrResult = 'No Cameras Found';
	}
	camerasFound(cams: MediaDeviceInfo[]) {
		this.availableDevices = cams;
		console.log("Devices", cams);
		if (cams && cams.length > 0) {
			this.selectedDevice = cams[0];
			this.camStarted = true;
		}
	}

	@ViewChild('scanner')
	scanner: ZXingScannerComponent;

	scannerSetUp: boolean = false;
	_visible: boolean = false;
	@Input()
	get visible(): boolean {
		return this._visible;
	}
	set visible(val: boolean) {
		this._visible = val;
		if (val) {

		}
	}

	camStarted = false;
	selectedDevice: any = null;
	searchText: string = "Searching...";
	qrResult = this.searchText;
	availableDevices: any[] = [];
	allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_93, BarcodeFormat.CODE_39, BarcodeFormat.CODE_128, BarcodeFormat.UPC_A];




	onChange(selectedValue: string) {
		this.camStarted = false;
		this.selectedDevice = selectedValue;
		if (selectedValue) {
			this.camStarted = true;
		}
	}
	constructor(
		public configData: ConfigService,
		private mySearchService: SearchService,
		private myPropertyItemService: PropertyItemService,
		private myStorageSpaceService: StorageSpaceService,
		private myActiveModal: NgbActiveModal
	) {
		super();
		this.activeModal = this.myActiveModal;
	}

	spaceFormatter = (value: TooBig4Car.Logic.StorageSpace) => value.FullStorageName;

	searchSpace = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term != '' && term.length > 2),
			map(a => a.trim()),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((term: string) => this.myStorageSpaceService.search(term))
		);

	onSelectSpace($event: any) {
		$event.preventDefault();
		this.myItem.NewStorageSpaceID = $event.item.StorageSpaceID;
		this.myItem.NewStorageSpaceName = $event.item.FullStorageName;
	}

	myItem = {} as TooBig4Car.Logic.PropertyItemMoveBulkVM;



	saveItem(form: NgForm) {
		if (!this.configData.IsEmptyGuid(this.myItem.NewStorageSpaceID)) {
			this.myPropertyItemService.moveBulk(this.myItem)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe((obj) => {
					this.closePopUp(obj);
				},
					(error: any) => {
						this.showValidationErrors(error, form);
					});
		}
	}
}
